// THIS CODE WAS AUTO-GENERATED from '/packages/icon/src/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props}>
    <path d="M12 2.2a9.65 9.65 0 0 0-10 9.29v.41a9.49 9.49 0 0 0 3.14 7.18.79.79 0 0 1 .27.56v1.78a.8.8 0 0 0 .82.78.82.82 0 0 0 .31-.07l2-.87a.72.72 0 0 1 .54 0 11.49 11.49 0 0 0 2.92.34 9.7 9.7 0 0 0 0-19.4Zm6 7.46-2.94 4.67a1.48 1.48 0 0 1-2.06.47l-.1-.06L10.56 13a.6.6 0 0 0-.72 0l-3.16 2.4a.48.48 0 0 1-.68-.66l2.94-4.66A1.49 1.49 0 0 1 11 9.61l.1.07 2.34 1.75a.6.6 0 0 0 .72 0L17.32 9a.48.48 0 0 1 .68.66Z" />
  </BaseIcon>
)
